module.exports = __webpack_public_path__ + "img/group-4370.16ab31af.svg";